export enum LocalStorageFields {
    AccountState = 'account_state',
    QuestionnaireState='questionnaire_state',
    PendingInvitationToken = 'pendingInvitationToken',
    PaymentReconciledThisSession = 'paymentReconciledThisSession',
    MarketingBookingContext = 'marketingBookingContext'
}